import moment from 'moment';

export const getDatetimeAMPMinUTC = (utcDate: string) => moment.utc(utcDate).format('MM/DD/YYYY hh:mm A');
